import { Button, Col, Grid, Input } from 'antd';
import React from 'react';
import { localize } from '/react4xp/mixins/helpers';
import SearchIcon from '/react4xp/parts/search/search-icon.svg';
import '/site/parts/search/search.scss';

const { useBreakpoint } = Grid;
const { Search: AntdSearch } = Input;

const Search = (props) => {
    const { md } = useBreakpoint();

    const onSearch = (value: Event) => open(`${props.url}?search=${value}`, '_self');

    const icon = (
        <span className="anticon anticon-user site-form-item-icon">
            <SearchIcon />
        </span>
    );

    return (
        <div className="search-block">
            <Col
                span={24}
                className="search-block__title"
            >
                {localize(
                    md ? 'search-state-services' : 'search-state-services-mobile',
                    props.translations
                )}
            </Col>

            <AntdSearch
                placeholder={localize('button.search', props.translations)}
                defaultValue={props.params.search}
                onSearch={onSearch}
                prefix={icon}
                enterButton={
                    <Button type="primary">{localize('button.search', props.translations)}</Button>
                }
            />
        </div>
    );
};

export default Search;
